<template>
  <home-layout>
    <terms-of-use/>
  </home-layout>
</template>

<script>
import HomeLayout from './../Layouts/HomeLayout'
import TermsOfUse from './../components/TermsOfUse'

export default {
  components: {
    HomeLayout,
    TermsOfUse,
  },
  metaInfo: {
    title: 'Kasutustingimused',
    meta: [
      { property: 'og:title', content: 'Kasutustingimused' },
      { property: 'robots', content: 'index, follow' },
    ]
  },
}
</script>
